class ProductZoomModal {
  constructor(enabled = true) {
    this.modal = null;
    this.enabled = enabled;
    this.isZoomed = false;
    this.isVideo = false;
    this.init();
  }

  init() {
    if (!this.enabled) return;

    // Create modal structure
    this.createModal();

    // Wait a bit for DOM to be ready, then replace modal-opener functionality
    setTimeout(() => {
      this.replaceModalOpeners();
    }, 500);

    // Also try immediately in case elements are already there
    this.replaceModalOpeners();
  }

  replaceModalOpeners() {
    // Find all modal-opener elements for images
    const modalOpeners = document.querySelectorAll('modal-opener.product__modal-opener--image');

    if (modalOpeners.length === 0) {
      // Fallback: Add click handlers directly to product media items
      const mediaItems = document.querySelectorAll('.product__media-item');

      mediaItems.forEach((item) => {
        const img = item.querySelector('img');
        const video = item.querySelector('video');

        // Skip if this is a video element
        if (video) {
          return;
        }

        if (img) {
          item.style.cursor = 'pointer';
          item.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.openModal(img.src, img.alt, false);
          });
        }
      });
      return;
    }

    modalOpeners.forEach((opener) => {
      // Replace the modal-opener with a simple div
      const wrapper = document.createElement('div');
      wrapper.className = 'custom-product-image-wrapper';
      wrapper.style.cursor = 'pointer';
      wrapper.innerHTML = opener.innerHTML;

      // Find the image and check for video
      const img = wrapper.querySelector('img');
      const video = wrapper.querySelector('video');

      // Skip if this is a video element
      if (video) {
        return;
      }

      if (img) {
        // Add click handler to the wrapper
        wrapper.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.openModal(img.src, img.alt, false);
        });
      }

      // Replace the modal-opener with our wrapper
      opener.parentNode.replaceChild(wrapper, opener);
    });
  }

  createModal() {
    // Create modal HTML
    const modalHTML = `
      <div id="product-zoom-modal" class="product-zoom-modal" style="display: none;">
        <div class="product-zoom-modal__overlay"></div>
        <button class="product-zoom-modal__close" aria-label="Close">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256">
            <path d="M202.83,197.17a4,4,0,0,1-5.66,5.66L128,133.66,58.83,202.83a4,4,0,0,1-5.66-5.66L122.34,128,53.17,58.83a4,4,0,0,1,5.66-5.66L128,122.34l69.17-69.17a4,4,0,1,1,5.66,5.66L133.66,128Z"></path>
          </svg>
        </button>
        <button class="product-zoom-modal__zoom-toggle" aria-label="Zoom">
          <svg class="zoom-in-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256">
            <path d="M148,112a4,4,0,0,1-4,4H116v28a4,4,0,0,1-8,0V116H80a4,4,0,0,1,0-8h28V80a4,4,0,0,1,8,0v28h28A4,4,0,0,1,148,112Zm78.83,114.83a4,4,0,0,1-5.66,0l-52.7-52.7a84.1,84.1,0,1,1,5.66-5.66l52.7,52.7A4,4,0,0,1,226.83,226.83ZM112,188a76,76,0,1,0-76-76A76.08,76.08,0,0,0,112,188Z"></path>
          </svg>
          <svg class="zoom-out-icon" style="display: none;" xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256">
            <path d="M148,112a4,4,0,0,1-4,4H80a4,4,0,0,1,0-8h64A4,4,0,0,1,148,112Zm78.83,114.83a4,4,0,0,1-5.66,0l-52.7-52.7a84.1,84.1,0,1,1,5.66-5.66l52.7,52.7A4,4,0,0,1,226.83,226.83ZM112,188a76,76,0,1,0-76-76A76.08,76.08,0,0,0,112,188Z"></path>
          </svg>
        </button>
        <div class="product-zoom-modal__content">
          <img class="product-zoom-modal__image" src="" alt="">
        </div>
      </div>
    `;

    // Append to body
    document.body.insertAdjacentHTML('beforeend', modalHTML);
    this.modal = document.getElementById('product-zoom-modal');
    this.modalImage = this.modal.querySelector('.product-zoom-modal__image');
    this.modalContent = this.modal.querySelector('.product-zoom-modal__content');
    this.zoomToggle = this.modal.querySelector('.product-zoom-modal__zoom-toggle');
    this.zoomInIcon = this.modal.querySelector('.zoom-in-icon');
    this.zoomOutIcon = this.modal.querySelector('.zoom-out-icon');

    // Add event listeners
    this.modal.querySelector('.product-zoom-modal__close').addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.closeModal();
    });

    // Zoom toggle button
    this.zoomToggle.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (!this.isVideo) {
        this.toggleZoom();
      }
    });

    // Click on content to zoom out when zoomed in
    this.modalContent.addEventListener('click', (e) => {
      if (this.isZoomed && e.target === this.modalContent) {
        e.preventDefault();
        e.stopPropagation();
        this.toggleZoom();
      }
    });

    // Close on ESC
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.style.display === 'flex') {
        e.preventDefault();
        this.closeModal();
      }
    });

    // Toggle zoom on image click (but not for videos)
    this.modalImage.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      // Only allow zoom if it's an image (not a video poster or placeholder)
      if (!this.isVideo) {
        this.toggleZoom();
      }
    });

    // Prevent right-click context menu
    this.modalImage.addEventListener('contextmenu', (e) => {
      e.preventDefault();
      return false;
    });
  }

  getLargeImageUrl(src) {
    // Convert Shopify image URL to a larger size
    // Remove any existing size parameters and add 2048x2048
    let newSrc = src;

    // Remove existing size parameters (e.g., _100x100, _300x, etc.)
    newSrc = newSrc.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master|[0-9]{1,4}x[0-9]{0,4})\.(jpg|jpeg|gif|png|bmp|bitmap|webp)/gi, '_2048x2048.$2');

    // If no size parameter was found, add one before the file extension
    if (newSrc === src) {
      newSrc = newSrc.replace(/\.(jpg|jpeg|gif|png|bmp|bitmap|webp)/gi, '_2048x2048.$1');
    }

    return newSrc;
  }

  openModal(src, alt, isVideo = false) {
    // Reset zoom state
    this.isZoomed = false;
    this.isVideo = isVideo;
    this.modalImage.classList.remove('loaded');
    this.modalImage.classList.remove('zoomed');
    this.modalContent.classList.remove('zoomed');

    // Reset zoom icons
    this.zoomInIcon.style.display = 'block';
    this.zoomOutIcon.style.display = 'none';

    // Hide zoom toggle for videos
    if (isVideo) {
      this.zoomToggle.style.display = 'none';
    } else {
      this.zoomToggle.style.display = 'flex';
    }

    // Get larger image URL (only for images, not videos)
    const largeImageSrc = isVideo ? src : this.getLargeImageUrl(src);

    // Set image source and alt
    this.modalImage.src = largeImageSrc;
    this.modalImage.alt = alt || '';

    // Update cursor style based on whether it's a video
    if (isVideo) {
      this.modalImage.style.cursor = 'default';
    } else {
      this.modalImage.style.cursor = 'zoom-in';
    }

    // Show modal
    this.modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';

    // Fade in modal
    requestAnimationFrame(() => {
      this.modal.classList.add('fade-in');
    });

    // Wait for image to load, then fade it in
    this.modalImage.onload = () => {
      this.modalImage.classList.add('loaded');
    };

    // If image is already cached, trigger load immediately
    if (this.modalImage.complete) {
      this.modalImage.classList.add('loaded');
    }
  }

  closeModal() {
    // Add fade-out class to trigger fade out animation
    this.modal.classList.add('fade-out');
    this.modal.classList.remove('fade-in');

    // Wait for fade out animation, then hide
    setTimeout(() => {
      this.modal.style.display = 'none';
      this.modal.classList.remove('fade-out');
      document.body.style.overflow = '';
      this.modalImage.classList.remove('loaded');
      this.modalImage.classList.remove('zoomed');
      this.modalContent.classList.remove('zoomed');
      this.isZoomed = false;
    }, 300);
  }

  toggleZoom() {
    if (!this.isZoomed) {
      // Zoom in
      this.modalImage.classList.add('zoomed');
      this.modalContent.classList.add('zoomed');
      this.isZoomed = true;
      // Enable clicking on content to zoom out
      this.modalContent.style.pointerEvents = 'auto';
      // Toggle icons
      this.zoomInIcon.style.display = 'none';
      this.zoomOutIcon.style.display = 'block';
    } else {
      // Zoom out
      this.modalImage.classList.remove('zoomed');
      this.modalContent.classList.remove('zoomed');
      this.isZoomed = false;
      // Reset pointer events
      this.modalContent.style.pointerEvents = '';
      // Toggle icons
      this.zoomInIcon.style.display = 'block';
      this.zoomOutIcon.style.display = 'none';
      // Reset scroll position
      this.modalContent.scrollTop = 0;
      this.modalContent.scrollLeft = 0;
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    // Check if custom zoom modal is enabled via data attribute
    const productInfo = document.querySelector('[data-custom-zoom-modal]');
    const enabled = productInfo ? productInfo.dataset.customZoomModal === 'true' : false;
    new ProductZoomModal(enabled);
  });
} else {
  // Check if custom zoom modal is enabled via data attribute
  const productInfo = document.querySelector('[data-custom-zoom-modal]');
  const enabled = productInfo ? productInfo.dataset.customZoomModal === 'true' : false;
  new ProductZoomModal(enabled);
}
